import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = {
  class: "d-flex flex-column mb-7 fv-row text-center fw-bold",
  style: {"font-size":"10px","line-height":"15px","color":"#4f4f4f"}
}
const _hoisted_4 = { class: "w-100" }
const _hoisted_5 = { class: "fv-row" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-lg-12" }
const _hoisted_8 = { class: "card-toolbar" }
const _hoisted_9 = {
  type: "button",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "top-start",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_10 = {
  src: "/media/svg/files/exclamation-circle.svg",
  alt: "",
  style: {"width":"auto"},
  class: "mx-2"
}
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-lg-6" }
const _hoisted_13 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center mb-10",
  for: "kt_create_account_form_account_type_personal"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x me-5 fs-7" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-venus" })
], -1)
const _hoisted_15 = { class: "d-block fw-bold text-start" }
const _hoisted_16 = { class: "text-dark fw-bolder d-block fs-4" }
const _hoisted_17 = { class: "col-lg-6" }
const _hoisted_18 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center",
  for: "kt_create_account_form_account_type_corporate"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x me-5 fs-7" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-mars" })
], -1)
const _hoisted_20 = { class: "d-block fw-bold text-start" }
const _hoisted_21 = { class: "text-dark fw-bolder d-block fs-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("This gives us options for certain clinical trials.")), 1)
    ], 512), [
      [_vShow, _ctx.info_onboarding_msg]
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createTextVNode(_toDisplayString(_ctx.$t("What is your gender?")) + " ", 1),
              _createElementVNode("a", _hoisted_9, [
                _withDirectives(_createElementVNode("img", _hoisted_10, null, 512), [
                  [_vShow, _ctx.info_home_msg]
                ])
              ]),
              _createVNode(_component_Tooltip)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_Field, {
              type: "radio",
              class: "btn-check",
              name: "gender",
              value: "female",
              required: "",
              id: "kt_create_account_form_account_type_personal"
            }),
            _createElementVNode("label", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("span", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("Female")), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_Field, {
              type: "radio",
              class: "btn-check",
              name: "gender",
              value: "male",
              id: "kt_create_account_form_account_type_corporate"
            }),
            _createElementVNode("label", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("span", _hoisted_20, [
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("Male")), 1)
              ])
            ])
          ]),
          _createVNode(_component_ErrorMessage, {
            name: "gender",
            class: "fv-plugins-message-container invalid-feedback"
          })
        ])
      ])
    ])
  ]))
}